import { FaShieldAlt, FaArrowRight } from 'react-icons/fa';
import styles from './TermsConditions.module.css';

const TermsConditions = () => {
  const lastUpdated = "15 de Mayo de 2024";

  return (
    <>
      <section className={styles.termsHero}>
        <div className={styles.heroContent}>
          <div className={styles.badge}>
            <FaShieldAlt className={styles.badgeIcon} />
            <span>Legal</span>
          </div>
          <h1>Términos y <span>Condiciones</span></h1>
          <p>
            Por favor, lea detenidamente estos términos y condiciones antes de utilizar nuestros servicios.
          </p>
          <div className={styles.lastUpdated}>
            Última actualización: {lastUpdated}
          </div>
        </div>
      </section>

      <section className={styles.termsSection}>
        <div className={styles.termsContainer}>
          <div className={styles.termsContent}>
            <div className={styles.termBlock}>
              <h2>1. Introducción</h2>
              <p>
                Estos Términos y Condiciones regulan el uso de los servicios ofrecidos por LUCQA ("nosotros", "nuestro" o "la Compañía"), 
                incluyendo nuestro sitio web, aplicaciones, productos y servicios relacionados (colectivamente, los "Servicios").
              </p>
              <p>
                Al acceder o utilizar nuestros Servicios, usted acepta estar legalmente vinculado por estos Términos y Condiciones. 
                Si no está de acuerdo con alguna parte de estos términos, no podrá acceder a nuestros Servicios.
              </p>
            </div>

            <div className={styles.termBlock}>
              <h2>2. Uso de los Servicios</h2>
              <p>
                Nuestros Servicios están destinados únicamente a personas mayores de 18 años. Al utilizar nuestros Servicios, 
                usted declara y garantiza que tiene al menos 18 años y que posee la capacidad legal para aceptar estos términos.
              </p>
              <p>
                Usted se compromete a utilizar nuestros Servicios únicamente para fines legales y de acuerdo con estos Términos y Condiciones. 
                Específicamente, usted acepta no:
              </p>
              <ul className={styles.termsList}>
                <li>Utilizar nuestros Servicios de manera fraudulenta o en conexión con actividades ilegales.</li>
                <li>Infringir los derechos de propiedad intelectual u otros derechos de terceros.</li>
                <li>Interferir con el funcionamiento normal de nuestros Servicios.</li>
                <li>Intentar acceder a áreas o información a las que no tiene autorización.</li>
                <li>Distribuir malware, virus o cualquier código diseñado para dañar o interferir con nuestros Servicios.</li>
              </ul>
            </div>

            <div className={styles.termBlock}>
              <h2>3. Propiedad Intelectual</h2>
              <p>
                Todos los derechos de propiedad intelectual relacionados con nuestros Servicios, incluyendo pero no limitado a 
                derechos de autor, marcas comerciales, nombres comerciales, código, gráficos y contenido, son propiedad exclusiva 
                de LUCQA o de nuestros licenciantes.
              </p>
              <p>
                Se le concede un derecho limitado, no exclusivo y no transferible para acceder y utilizar nuestros Servicios para 
                su uso personal y no comercial. No se le otorga ningún derecho para reproducir, duplicar, copiar, vender, revender 
                o explotar cualquier parte de nuestros Servicios sin nuestro consentimiento expreso por escrito.
              </p>
            </div>

            <div className={styles.termBlock}>
              <h2>4. Privacidad</h2>
              <p>
                Su privacidad es importante para nosotros. Nuestra Política de Privacidad, que está incorporada a estos Términos y Condiciones, 
                describe cómo recopilamos, utilizamos y protegemos su información personal cuando utiliza nuestros Servicios.
              </p>
              <p>
                Al utilizar nuestros Servicios, usted acepta el procesamiento de su información como se describe en nuestra Política de Privacidad.
              </p>
            </div>

            <div className={styles.termBlock}>
              <h2>5. Limitación de Responsabilidad</h2>
              <p>
                En la medida máxima permitida por la ley aplicable, LUCQA no será responsable por daños indirectos, incidentales, 
                especiales, consecuentes o punitivos, o por cualquier pérdida de beneficios o ingresos, ya sea incurrida directa o 
                indirectamente, o cualquier pérdida de datos, uso, buena voluntad u otras pérdidas intangibles, resultantes de:
              </p>
              <ul className={styles.termsList}>
                <li>Su acceso o uso, o incapacidad para acceder o usar los Servicios.</li>
                <li>Cualquier conducta o contenido de terceros en los Servicios.</li>
                <li>Acceso no autorizado, uso o alteración de sus transmisiones o contenido.</li>
              </ul>
            </div>

            <div className={styles.termBlock}>
              <h2>6. Modificaciones</h2>
              <p>
                Nos reservamos el derecho, a nuestra sola discreción, de modificar o reemplazar estos Términos y Condiciones en cualquier momento. 
                Si una revisión es material, intentaremos proporcionar un aviso con al menos 30 días de anticipación antes de que los nuevos 
                términos entren en vigor.
              </p>
              <p>
                Su uso continuado de nuestros Servicios después de que las modificaciones entren en vigor constituirá su aceptación de los 
                nuevos términos. Si no está de acuerdo con los nuevos términos, deje de utilizar nuestros Servicios.
              </p>
            </div>

            <div className={styles.termBlock}>
              <h2>7. Ley Aplicable</h2>
              <p>
                Estos Términos y Condiciones se regirán e interpretarán de acuerdo con las leyes de España, sin tener en cuenta 
                sus disposiciones sobre conflictos de leyes.
              </p>
              <p>
                Cualquier disputa que surja en relación con estos Términos y Condiciones estará sujeta a la jurisdicción exclusiva 
                de los tribunales de Madrid, España.
              </p>
            </div>

            <div className={styles.termBlock}>
              <h2>8. Contacto</h2>
              <p>
                Si tiene alguna pregunta sobre estos Términos y Condiciones, por favor contáctenos a través de:
              </p>
              <div className={styles.contactInfo}>
                <p>Email: legal@lucqa.com</p>
                <p>Teléfono: +34 91 123 45 67</p>
                <p>Dirección: Calle Ejemplo 123, 28001 Madrid, España</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.ctaSection}>
        <div className={styles.ctaContainer}>
          <div className={styles.ctaContent}>
            <h2>¿Necesita ayuda legal adicional?</h2>
            <p>Nuestro equipo está disponible para resolver cualquier duda relacionada con nuestros términos y condiciones.</p>
            <button className={styles.ctaButton}>
              Contactar <FaArrowRight />
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsConditions;